/* src/app/pages/carrusel/carrusel.component.css */
.destacados-container {
  max-width: 996px;
  width: 100%;
  height: 545px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.titulo-destacados {
  font-family: "Gotham Bold";
  font-size: 25px;
  line-height: 30px;
  color: #323E48;
  align-self: flex-start;
  margin: 0 0 40px 0;
}
.carousel-contenedor {
  display: flex;
  width: 996px;
  justify-content: center;
  align-items: flex-start;
  gap: 48px;
}
.inmueble-card {
  display: flex;
  width: 300px;
  height: 407px;
  flex-direction: column;
  align-items: stretch;
  flex-shrink: 0;
  overflow: hidden;
}
.card-img-top {
  width: 300px;
  height: 150px;
  object-fit: cover;
  display: block;
}
.card-body {
  padding: 10px 20px 20px 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.inmueble-desc {
  font-family: "Gotham Medium";
  font-size: 13px;
  color: #5B6670;
  display: block;
  text-align: left;
  margin: 0px;
  line-height: 18px;
  height: 36px;
  overflow: hidden;
}
.inmueble-price {
  font-family: "Gotham Medium";
  font-size: 18px;
  line-height: 23px;
  color: #323E48;
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
}
.inmueble-datos {
  margin: 0px;
  padding: 0px;
}
.inmueble-datos label {
  font-family: "Gotham Book";
  font-size: 15px;
  color: #5B6670;
  display: block;
  line-height: 20px;
}
.btn-detalle {
  margin-top: 10px;
  padding: 10px 0px;
  display: flex;
  color: #EB0029;
  font-size: 13px;
  cursor: pointer;
  font-family: "Gotham Medium";
  line-height: 16px;
}
.carousel-controles {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 64px;
  height: 25px;
  margin-top: 41.96px;
}
.custom-arrow {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
}
.custom-arrow img {
  width: 22px;
  height: 22px;
}
.carousel-indicators-custom {
  display: flex;
  gap: 14px;
}
.carousel-indicators-custom button {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: none;
  background-color: #A2A9AD;
  cursor: pointer;
  padding: 0;
  box-sizing: content-box;
}
.carousel-indicators-custom .active {
  background-color: #BD001F;
  width: 24px;
  height: 8px;
  border-radius: 7px;
}
.carousel-indicators.carousel-indicators-custom {
  position: static !important;
  margin: 0;
}
@media (max-width: 1100px) {
  .titulo-destacados {
    padding: 0 54px;
  }
}
@media (max-width: 473.5px) {
  .titulo-destacados {
    padding: 0 16px;
  }
}
/*# sourceMappingURL=/banorte/__host/inmuebles/Inmuebles/carrusel.component.css.map */
